import React from "react";
import cogoToast from "cogo-toast";
// import Explanation from "../modals/Explanation";
// const confetti = require('canvas-confetti')

class FillInBlank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
      open: false,
      optionSelected: "",
      quiz_data: {
        quiz_title: ""
      },
      question_list: {
        question_title: "",
        question_media: [
          {
            media_path: ""
          }
        ],
        question_options: [
          {
            option_name: "",
            option_id: ""
          }
        ]
      },
      ans: [],
      count: 0,
      rightAns: "none",
      wrongAns: "none",
      quiz_answers: [],
      date: 0
    };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }
  tick() {
    this.setState({ date: this.state.date + 1 });
  }
  componentWillMount() {
    this.setState({
      question_list: this.props.unitDetails,
      // quiz_data: this.props.Details.quiz_list[0],
      start: this.state.date
    });
    // this.setState({ quiz_data: this.props.Details.quiz_list[0] });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.unitDetails.question_title !== this.props.unitDetails.question_title) {
      this.setState({
        question_list: this.props.unitDetails,
      });
    }
  }
  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  findAns = ans => {
    return this.state.question_list.question_options.find(item => {
      return parseInt(item.option_id, 10) === parseInt(ans, 10);
    });
  };

  onOptionSelection = event => {
    event.target.classList.add("selected-radio");
    const allRadioButtons = document.querySelectorAll(".radio-button");
    for (let i = 0; i < allRadioButtons.length; i++) {
      allRadioButtons[i].classList.add("disabled");
    }
    this.setState({ error: "" });
    this.setState({ optionSelected: event.target.value });
    this.setState({ rightAns: "none", wrongAns: "none" });
    this.setState({ ans: this.state.optionSelected });
    var ans = this.findAns(event.target.value);
    let obj = {};
    obj.quiz_unit_id = this.state.quiz_data.quiz_unit_id;
    obj.course_unit_id = this.props.Details.course_unit_id;
    obj.coursemaster_id = this.props.Details.coursemaster_id;
    obj.question_id = this.state.question_list.main_question_id;
    obj.start_time = this.state.start;
    obj.no_of_attempted = 1;
    obj.total_point = 5;
    if (event.target.getAttribute("data") == 1) {
      this.setState({ rightAns: "block", wrongAns: "none" });
      obj.answer_id = event.target.id;
      obj.obtained_score = this.state.quiz_data.marks_for_correct_answer;
      obj.accuracy =
        (100 * this.state.quiz_data.marks_for_correct_answer) /
        this.state.quiz_data.marks_for_correct_answer;
      obj.obtained_point = 5;
      this.props.playCorrectAudio();
      cogoToast.success("Correct", { position: "top-center" });

      window.confetti()
      var a = {};
      a.answer = "Correct";
      a.text = this.state.question_list.correct_feedback;
      a.video = this.state.question_list.correct_feedback_video;
      this.setState({ open: true, explain_data: a });
      // event.target.classList.add("correct-answer");
    } else {
      cogoToast.error("Wrong", { position: "top-center" });
      this.setState({ rightAns: "none", wrongAns: "block" });
      obj.answer_id = event.target.id;
      obj.obtained_score = 0;
      obj.accuracy = (100 * 0) / this.state.quiz_data.marks_for_correct_answer;
      obj.obtained_point = 0;
      const allRadioButton = document.querySelectorAll(".radio-button");
      this.props.playIncorrectAudio();
      var a = {};
      a.answer = "Wrong";
      a.text = this.state.question_list.incorrect_feedback;
      a.video = this.state.question_list.incorrect_feedback_video;
      this.setState({ open: true, explain_data: a });
    }
    obj.time_spent_duration = parseInt(this.state.date) - parseInt(this.state.start);
    obj.total_score = this.state.quiz_data.marks_for_correct_answer;
    obj.end_time = this.state.date;
    // quiz.push(obj);
    // console.log(quiz);
    // this.setState({ quiz_answers: quiz });
    if (localStorage.getItem("quiz")) {
      var scores = JSON.parse(localStorage.getItem('quiz'))
      var exist = false
      for (let i = 0; i < scores.length; i++) {
        if (obj.question_id == scores[i].question_id) {
          scores[i] = obj
          exist = true
          localStorage.setItem("quiz", JSON.stringify(scores));
        }
      }
      if (!exist) {
        var cart = [];
        cart = JSON.parse(localStorage["quiz"]);
        cart.push(obj);
        localStorage.setItem("quiz", JSON.stringify(cart));
      }
    } else {
      var arra = [];
      arra.push(obj);
      console.log(arra);
      localStorage.setItem("quiz", JSON.stringify(arra));
    }
    // document.querySelector('.next-btn').classList.add('disable')
  };
  nextque = () => {
    this.props.parentMethod();
  };
  onOpenModal_Explain = () => {
    this.setState({ open: true });
  };
  onCloseModal_Explain = () => {
    this.setState({ open: false });
    const allRadioButtons = document.querySelectorAll(".radio-button");
    for (let i = 0; i < allRadioButtons.length; i++) {
      allRadioButtons[i].classList.add("disabled");
    }
    setTimeout(() => {
      this.nextque();
      if (document.querySelector(".selected-radio")) {
        document
          .querySelector(".selected-radio")
          .classList.remove("selected-radio");
      }
      for (let i = 0; i < allRadioButtons.length; i++) {
        allRadioButtons[i].classList.remove("disabled");
      }
    }, 100);

  };
  render() {
    return (
      <div className="quiz-model quiz_sentence_type">
        <div className="rounded">
          <div className="heading-block">
            <p
              className="text-4 text-black m-0 question-quiz text-center" id="question_title"
              dangerouslySetInnerHTML={{
                __html: this.state.question_list.question_title
              }}
            ></p>
          </div>
          <div className="modal-body">
            <div className="row inner-game-container mx-auto justify-content-center">
              <div className="col-md-6">
                <div className="radio-div d-flex justify-content-center align-items-center flex-column">
                  {this.state.question_list.question_options.map((op, key) => (
                    <div
                      class="radio-button shadow-sm"
                      id={key}
                      onClick={this.onOptionSelection.bind(this)}
                      data={op.right_answer}
                    >
                      {op.option_name}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row d-flex justify-content-center my-3 next-btn disable"></div>
        {/* <Explanation
          explain_data={this.state.explain_data}
          open={this.state.open}
          close={this.onCloseModal_Explain}
        /> */}
      </div>
    );
  }
}
export default FillInBlank;
